/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Missing_Team_Project_Id_ErrorInputs */

const en_explorer_search_missing_team_project_id_error = /** @type {(inputs: Explorer_Search_Missing_Team_Project_Id_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing team or project ID in file`)
};

const fr_explorer_search_missing_team_project_id_error = /** @type {(inputs: Explorer_Search_Missing_Team_Project_Id_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing team or project ID in file`)
};

const de_explorer_search_missing_team_project_id_error = /** @type {(inputs: Explorer_Search_Missing_Team_Project_Id_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing team or project ID in file`)
};

const it_explorer_search_missing_team_project_id_error = /** @type {(inputs: Explorer_Search_Missing_Team_Project_Id_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing team or project ID in file`)
};

const ru_explorer_search_missing_team_project_id_error = /** @type {(inputs: Explorer_Search_Missing_Team_Project_Id_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing team or project ID in file`)
};

const es_explorer_search_missing_team_project_id_error = /** @type {(inputs: Explorer_Search_Missing_Team_Project_Id_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing team or project ID in file`)
};

const zh_cn2_explorer_search_missing_team_project_id_error = /** @type {(inputs: Explorer_Search_Missing_Team_Project_Id_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing team or project ID in file`)
};

const ja_explorer_search_missing_team_project_id_error = /** @type {(inputs: Explorer_Search_Missing_Team_Project_Id_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing team or project ID in file`)
};

const hi_explorer_search_missing_team_project_id_error = /** @type {(inputs: Explorer_Search_Missing_Team_Project_Id_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing team or project ID in file`)
};

const pt_pt2_explorer_search_missing_team_project_id_error = /** @type {(inputs: Explorer_Search_Missing_Team_Project_Id_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing team or project ID in file`)
};

/**
* | output |
* | --- |
* | "Missing team or project ID in file" |
*
* @param {Explorer_Search_Missing_Team_Project_Id_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_missing_team_project_id_error = /** @type {((inputs?: Explorer_Search_Missing_Team_Project_Id_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Missing_Team_Project_Id_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_search_missing_team_project_id_error(inputs)
	if (locale === "de") return de_explorer_search_missing_team_project_id_error(inputs)
	if (locale === "it") return it_explorer_search_missing_team_project_id_error(inputs)
	if (locale === "ru") return ru_explorer_search_missing_team_project_id_error(inputs)
	if (locale === "es") return es_explorer_search_missing_team_project_id_error(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_search_missing_team_project_id_error(inputs)
	if (locale === "ja") return ja_explorer_search_missing_team_project_id_error(inputs)
	if (locale === "hi") return hi_explorer_search_missing_team_project_id_error(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_search_missing_team_project_id_error(inputs)
	return en_explorer_search_missing_team_project_id_error(inputs)
});